var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgNp2 = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 41,
    viewBox: "0 0 31 41",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m2.6 33.718 12.425-10.394c5.539-4.67 7.514-7.31 7.514-10.874 0-3.987-2.862-6.203-6.425-6.203-3.323 0-5.538 1.55-7.975 4.45-.665.664-1.31 1.089-2.64 1.089-1.772 0-3.102-1.311-3.102-3.102 0-.886.203-1.55.665-2.197C6.385 2.5 10.152.063 16.576.063c7.975 0 13.292 4.633 13.292 11.963 0 6.184-3.341 9.747-10.412 15.489L11.037 34.4h16.394c1.772 0 3.102 1.33 3.102 3.101 0 1.551-1.33 3.102-3.102 3.102H4.613c-2.216 0-3.988-1.348-3.988-3.323 0-1.55.665-2.677 1.975-3.563",
    clipRule: "evenodd"
  })));
};
const Memo = /*#__PURE__*/memo(SvgNp2);
export default Memo;